import { Controller } from '@hotwired/stimulus'
import { emit } from '../lib/events'

export default class extends Controller {
  handleClick = (event) => {
    emit('clicked', {
      bubbles: true,
      detail: { event: event },
    })
  }
}
